import { getEnvironmentConfig } from './environment';

const STORAGE_KEY = 'indysoft_environmentId';

export const getEnvironmentId = (): string | null => {
  return localStorage.getItem(STORAGE_KEY);
};

export const setEnvironmentId = (id: string): void => {
  localStorage.setItem(STORAGE_KEY, id);
};

export const clearEnvironmentId = (): void => {
  localStorage.removeItem(STORAGE_KEY);
};

const isValidEnvironmentId = (id: string): boolean => {
  return /^[a-zA-Z0-9-]+$/.test(id) && id.length <= 100;
};

export const initializeEnvironmentId = (): boolean => {
  const urlParams = new URLSearchParams(window.location.search);
  const urlEnvironmentId = urlParams.get('environmentId');
  const storedEnvironmentId = getEnvironmentId();

  if (urlEnvironmentId && isValidEnvironmentId(urlEnvironmentId)) {
    if (urlEnvironmentId !== storedEnvironmentId) {
      setEnvironmentId(urlEnvironmentId);
    }

    // Clean URL (remove environmentId param)
    urlParams.delete('environmentId');
    const newSearch = urlParams.toString();
    const newUrl =
      window.location.pathname +
      (newSearch ? '?' + newSearch : '') +
      window.location.hash;
    history.replaceState(null, '', newUrl);

    return true;
  }

  if (storedEnvironmentId) {
    return true;
  }

  // Dev fallback: use .env environment ID so local dev doesn't require the query param
  if (import.meta.env.DEV) {
    const devEnvId = import.meta.env.VITE_ENVIRONMENT_ID_DEV;
    if (devEnvId) {
      setEnvironmentId(devEnvId);
      return true;
    }
  }

  return false;
};

export const redirectToAuthBridge = (): void => {
  const { authBridgeUrl } = getEnvironmentConfig();

  if (!authBridgeUrl) {
    console.error('[EnvironmentId] AuthBridge URL not configured');
    return;
  }

  const returnUrl = encodeURIComponent(window.location.href);
  window.location.href = `${authBridgeUrl}?returnUrl=${returnUrl}&select=true`;
};

export const switchEnvironment = (): void => {
  clearEnvironmentId();

  const { authBridgeUrl } = getEnvironmentConfig();

  if (!authBridgeUrl) {
    console.error('[EnvironmentId] AuthBridge URL not configured');
    return;
  }

  const returnUrl = encodeURIComponent(window.location.href);
  window.location.href = `${authBridgeUrl}?returnUrl=${returnUrl}&select=true`;
};
